// extracted by mini-css-extract-plugin
module.exports = {"additionalInformationBlock":"AdditionalInformation_additionalInformationBlock__9ggze","additionalInformationsTitle":"AdditionalInformation_additionalInformationsTitle__sKg7N"};